import { ReactNode } from "react";
import AppContext from "./context";
import { useInitizeAppState } from "../hooks/useInitiazeAppState";

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const [appState, setAppState] = useInitizeAppState();

  return <AppContext.Provider value={appState}>{children}</AppContext.Provider>;
};
